export default __webpack_public_path__ + "static/media/2072.17cf3761.png";